<template>
  <div id="app">
    <!-- <button @click="$store.dispatch('modal/error', 'Hello World!')">CLICK</button> -->
    <Modal
      :config="modalConfig"
      @close-modal="$store.dispatch('modal/close')"
    />
    <div class="main-flex">
      <NavigationBar />
      <router-view />
    </div>
    <footer class="footer bottom-flex has-background-white-ter">
      <div class="container has-text-centered">
        <p>
          <strong>{{ $product.name }}</strong> by
          <a href="https://www.insilicotrials.com">InSilicoTrials Technologies</a>
          <br>
          <router-link :to="{name: 'terms'}">
            Terms and Conditions
          </router-link>&nbsp;apply.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NavigationBar from './components/NavigationBar.vue';

export default {
  components: {
    NavigationBar,
  },
  computed: {
    ...mapState('modal', {
      modalConfig: (state) => state.config,
    }),
  },
};
</script>

<style lang="scss">

</style>
